import { render, staticRenderFns } from "./LTIChooserCureum.vue?vue&type=template&id=db4cf350"
import script from "./LTIChooserCureum.vue?vue&type=script&lang=js"
export * from "./LTIChooserCureum.vue?vue&type=script&lang=js"
import style0 from "./LTIChooserCureum.vue?vue&type=style&index=0&id=db4cf350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports